// ────────────────────────────────────────────────────────────────────
// Shared composer "+" tray — ONE implementation of the LINE-style
// stretch-out tool tray used by BOTH dock composers (team chat + MODS),
// so the press-+ effect is identical everywhere by construction: same
// rotation, same easing/duration, same gaps. Only the tools inside and
// the stretch width (per tool count) differ.
// ────────────────────────────────────────────────────────────────────
import { type ReactNode } from "react";
import { Plus } from "lucide-react";

export function TrayToggle({ open, onClick, label = "เครื่องมือ" }: {
  open: boolean; onClick: () => void; label?: string;
}): JSX.Element {
  return (
    <button type="button" onClick={onClick} aria-label={label} aria-expanded={open}
            className="p-1 shrink-0">
      <Plus size={17} style={{ color: open ? "var(--accent-deep)" : "var(--ink-3)",
                               transform: open ? "rotate(45deg)" : "none",
                               transition: "transform 140ms ease" }} />
    </button>
  );
}

export function ComposerTray({ open, width, children }: {
  open: boolean;
  /** Expanded width in px — roughly 36 per tool button. */
  width: number;
  children: ReactNode;
}): JSX.Element {
  return (
    <div aria-hidden={!open} className="flex items-center gap-0.5 shrink-0"
         style={{ overflow: "hidden", maxWidth: open ? width : 0,
                  opacity: open ? 1 : 0,
                  transition: "max-width 160ms ease, opacity 120ms ease" }}>
      {children}
    </div>
  );
}
